import { createFileRoute } from "@tanstack/react-router";
import { Admin2faSetupPage } from "@/components/admin/Admin2faSetupPage";

export const Route = createFileRoute("/pulse-ops-x7k2/setup-2fa")({
  component: Admin2faSetupPage,
});
